import { useState, useEffect } from 'react';
import { useAdminApi } from '../hooks/useAdminApi';
import { Link2, CheckCircle2, X, Wrench, Building2 } from 'lucide-react';
import { toast } from 'sonner';

export default function AtelierInvitationBanner() {
  const { get, post } = useAdminApi();
  const [invitations, setInvitations] = useState([]);

  useEffect(() => {
    const fetch = async () => {
      const res = await get('/mechanic/admin/atelier-invitations');
      if (res.success) setInvitations(res.data || []);
    };
    fetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleAccept = async (connId) => {
    const res = await post(`/mechanic/admin/atelier-invitations/${connId}/accept`);
    if (res.success) {
      toast.success('Connexion etablie avec l\'atelier!');
      setInvitations(prev => prev.filter(i => i.id !== connId));
    } else {
      toast.error(res.error || 'Erreur');
    }
  };

  const handleReject = async (connId) => {
    const res = await post(`/mechanic/admin/atelier-invitations/${connId}/reject`);
    if (res.success) {
      toast.success('Invitation refusee');
      setInvitations(prev => prev.filter(i => i.id !== connId));
    }
  };

  if (invitations.length === 0) return null;

  return (
    <div className="space-y-2" data-testid="atelier-invitations">
      {invitations.map(inv => (
        <div key={inv.id} className="bg-amber-500/10 border border-amber-500/30 rounded-xl p-4" data-testid={`invitation-${inv.id}`}>
          <div className="flex items-start justify-between gap-3">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 bg-amber-500/20 rounded-full flex items-center justify-center shrink-0">
                <Wrench size={18} className="text-amber-400" />
              </div>
              <div>
                <p className="text-white font-medium text-sm">Invitation atelier: {inv.atelier_name}</p>
                <p className="text-slate-400 text-xs mt-0.5">
                  {inv.atelier_name} souhaite se connecter a votre flotte pour le suivi d'entretien (inspections, mesures, stats).
                </p>
                <p className="text-slate-500 text-[10px] mt-1">Invite par: {inv.invited_by_name}</p>
              </div>
            </div>
            <div className="flex items-center gap-2 shrink-0">
              <button
                onClick={() => handleAccept(inv.id)}
                className="bg-green-500 hover:bg-green-400 text-black text-xs font-semibold px-3 py-1.5 rounded-lg flex items-center gap-1 transition-colors"
                data-testid={`accept-${inv.id}`}
              >
                <CheckCircle2 size={12} /> Accepter
              </button>
              <button
                onClick={() => handleReject(inv.id)}
                className="bg-slate-800 hover:bg-slate-700 text-slate-400 text-xs px-2.5 py-1.5 rounded-lg transition-colors"
                data-testid={`reject-${inv.id}`}
              >
                <X size={12} />
              </button>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
